import React, { useContext } from 'react';
import { Navigate } from 'react-router-dom';
import { UserContext } from '../Context/Usercontext';

export default function RoleProtector({ children, requiredRole }) {

    const { userRole } = useContext(UserContext);

    console.log(userRole, requiredRole);

    if (userRole === requiredRole) {
        return children;
    } else {
        return <Navigate to="/login" />;
    }
}
